import Button from 'react-bootstrap/esm/Button';
import './common.scss';
import "./components/styles/faces.css";
import Logo from './images/makro-logo.png'

// import { FreeComment } from './components/FreeComment';
import { TeenScaleValue } from './components/TeenScaleValue'
import { SerializeForm } from './utils/SerializeForm';
import { useEffect, useState} from 'react';
// import { LikeOrDislike } from './components/LikeOrDislike';
import { Table } from 'react-bootstrap';

import face1 from './images/1.png';
import face2 from './images/2.png';
import face3 from './images/3.png';
import face4 from './images/4.png';
import face5 from './images/5.png';


function App() {

const [probabilidadRecomendacion, setProbabilidadRecomendacion] = useState(null)


const [uuid, setUuid] = useState(null);

const [ready, setReady] = useState(false)
const [isSubmitting, setIsSubmitting] = useState(false);
const [submitSuccess, setSubmitSuccess] = useState(false);
const [submitError, setsubmitError] = useState(false)
const today = new Date().toISOString().split('T')[0]; // yyyy-mm-dd
const [numeroPregunta,setNumeroPregunta] =useState(0);  
const [nombreError, setNombreError] = useState(false);
const [emailError, setEmailError] = useState(false);
const [tiendaError, setTiendaError] = useState(false);


// 🧍 Datos del cliente
const [nombre, setNombre] = useState("");
const [dniCuitCliente, setDniCuitCliente] = useState("");
const [emailCliente, setEmailCliente] = useState("");
const [telefonoCliente, setTelefonoCliente] = useState("");
const [dniCuitError, setDniCuitError] = useState(false);

// ⏱️ Comportamiento y tiempos
const [minutoResponder, setMinutoResponder] = useState("");

// 💬 Satisfacción general
const [satisfaccionGeneral, setSatisfaccionGeneral] = useState("");
const [comentarioInsatisfaccion, setComentarioInsatisfaccion] = useState("");

// 🏬 Experiencia en el local
const [facilidadCompra, setFacilidadCompra] = useState("");
const [contactoGestion, setContactoGestion] = useState("");
const [inicioCompra, setInicioCompra] = useState("");
const [distribucionComunicacion, setDistribucionComunicacion] = useState("");

// 🛒 Productos
const [productosBuscados, setProductosBuscados] = useState("");
const [noEncontroProducto, setNoEncontroProducto] = useState("");
const [noEncontroMarca, setNoEncontroMarca] = useState("");
const [noEncontreFormatoGramaje, setNoEncontreFormatoGramaje] = useState("");
const [alternativasProductos, setAlternativasProductos] = useState("");
const [productosCalidad, setProductosCalidad] = useState("");
const [problemaProductoCalidad, setProblemaProductoCalidad] = useState("");
const [productoCalidadDetalle, setProductoCalidadDetalle] = useState("");
const [productoCalidadDetalleOtro, setProductoCalidadDetalleOtro] = useState("");

// 💰 Ofertas y precios
const [encontreBuenosPrecios, setEncontreBuenosPrecios] = useState("");
const [ofertasAtractivas, setOfertasAtractivas] = useState("");
const [entenderOfertas, setEntenderOfertas] = useState("");
const [localLimpioOrdenado, setLocalLimpioOrdenado] = useState("");

// 🙋 Atención y pago
const [atencionPersonal, setAtencionPersonal] = useState("");
const [atencionPersonalSector, setAtencionPersonalSector] = useState("");
const [atencionPersonalProblema, setAtencionPersonalProblema] = useState("");
const [procesoPago, setProcesoPago] = useState("");
const [motivoCajaEsperaLarga, setMotivoCajaEsperaLarga] = useState("");
const [motivoMedioPago, setMotivoMedioPago] = useState("");
const [motivoAtencionCajero, setMotivoAtencionCajero] = useState("");
const [motivoOtro, setMotivoOtro] = useState("");
const [motivoOtroTexto, setMotivoOtroTexto] = useState("");
const [motivoPocasCajas, setMotivoPocasCajas] = useState("");
const [motivoPrecioDiferente, setMotivoPrecioDiferente] = useState("");
const [motivoPrioridad, setMotivoPrioridad] = useState("");

// 🛍️ Compra y lealtad
const [compraAnterior, setCompraAnterior] = useState("");
const [escalaSatistaccion, setEscalaSatistaccion] = useState("");
const [volverComprar, setVolverComprar] = useState("");

// 🗒️ Comentarios generales
const [comentarioMejorar, setComentarioMejorar] = useState("");
const [comentarioSatisfaccion, setComentarioSatisfaccion] = useState("");
const [comentarioCompraAnteriorOtro, setComentarioCompraAnteriorOtro] = useState("");

// 🏪 Campos globales (tienda y política)
const [tiendaId, setTiendaId] = useState("");
const [aceptaPolitica, setAceptaPolitica] = useState(false);

const options = [
  { value: 5, color: "#b3ffcc", img: face5, label: "Muy satisfecho" },
  { value: 4, color: "#d9ffb3", img: face4, label: "Satisfecho" },
  { value: 3, color: "#fff0b3", img: face3, label: "Neutral" },
  { value: 2, color: "#ffd1b3", img: face2, label: "Insatisfecho" },
  { value: 1, color: "#ffb3b3", img: face1, label: "Muy insatisfecho" },
];  
const sucursales = [
  { id: 2, nombre: "Avellaneda", zona: "GBA" },
  { id: 25, nombre: "Benavidez", zona: "GBA" },
  { id: 14, nombre: "Bahía Blanca", zona: "Interior" },
  { id: 21, nombre: "Córdoba Juan B. Justo", zona: "Interior" },
  { id: 4, nombre: "Córdoba Colón", zona: "Interior" },
  { id: 20, nombre: "Corrientes", zona: "Interior" },
  { id: 3, nombre: "Haedo", zona: "GBA" },
  { id: 15, nombre: "Ituzaingó", zona: "GBA" },
  { id: 8, nombre: "Lomas de Zamora", zona: "GBA" },
  { id: 12, nombre: "Mar del Plata", zona: "Interior" },
  { id: 11, nombre: "Mendoza", zona: "Interior" },
  { id: 17, nombre: "Neuquén", zona: "Interior" },
  { id: 1, nombre: "Olivos", zona: "GBA" },
  { id: 23, nombre: "Pilar", zona: "GBA" },
  { id: 22, nombre: "Posadas", zona: "Interior" },
  { id: 6, nombre: "Quilmes", zona: "GBA" },
  { id: 18, nombre: "Río Cuarto", zona: "Interior" },
  { id: 5, nombre: "Rosario", zona: "Interior" },
  { id: 24, nombre: "Salta", zona: "Interior" },
  { id: 19, nombre: "San Juan", zona: "Interior" },
  { id: 9, nombre: "San Justo", zona: "GBA" },
  { id: 10, nombre: "San Martín", zona: "GBA" },
  { id: 13, nombre: "Santa Fe", zona: "Interior" },
  { id: 16, nombre: "Tucumán", zona: "Interior" },
];

// const zonas = ["GBA", "Interior"];


  // Se ejecuta la primera vez que se carga la pagina
  useEffect(() => {
    const url = new URL(window.location.href)

    // if (url.searchParams.has('param-option-selected'))
    // setProbabilidadRecomendacion(url.searchParams.get('param-option-selected'))
    // setTiendaId(url.searchParams.get('store'))
    // setEnvioId(url.searchParams.get('send'))
    // setEnvioFechaHora(url.searchParams.get('send-date-time'))
    // setVisitaFecha(url.searchParams.get('visit-date'))
    // setTipoCliente(url.searchParams.get('tipo-cliente'))
    // setClienteNro(url.searchParams.get('cliente-nro'))
    // setEmailCliente(url.searchParams.get('utm_email'))

  // siempre intenta cargar 'store'
  if (url.searchParams.has('store')) {
    setTiendaId(url.searchParams.get('store'));
  // console.log("store:", url.searchParams.get('store'));

  }

    setReady(true)
  }, [])

useEffect(() => {
  setUuid(prev => prev ?? crypto.randomUUID());
}, []);

// useEffect(() => {
//   console.log("useEffect ejecutado. UUID:", uuid);

//   if (!uuid  || submitSuccess) return;
//     console.log("Entra");

//     const interval = setInterval(() => {
//     const form = document.querySelector("form");
//     if (!form) return;

//     let data = SerializeForm(form);
//     data.push({ key: "uuid", value: uuid });

//     fetch("http://127.0.0.1:8882/send_nps_makro", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ data })
//     });

//     console.log("⏱️ Parcial enviado", uuid);

//   }, 10000);

//   return () => {
//     console.log("🧹 Limpia interval");
//     clearInterval(interval);
//   };

// }, [uuid,submitSuccess]);

// ----------------------------------------------
useEffect(() => {
  if (!uuid || submitSuccess) return;

  const interval = setInterval(() => {
    // Mapeo de estados de React a campos de BigQuery
    const formData = {
      uuid,
      nombre_apellido_cliente: nombre || "",
      dni_cuit_cliente: dniCuitCliente || "",
      email_cliente: emailCliente || "",
      telefono_cliente: telefonoCliente || "",
      minutos_responder: minutoResponder || "",
      satisfaccion_general: satisfaccionGeneral || "",
      comentario_insatisfaccion: comentarioInsatisfaccion || "",
      facilidad_compra: facilidadCompra || "",
      contacto_gestion: contactoGestion || "",
      inicio_compra: inicioCompra || "",
      distribucion_comunicacion: distribucionComunicacion || "",
      productos_buscados: productosBuscados || "",
      no_encontro_producto: noEncontroProducto || "",
      no_encontro_marca: noEncontroMarca || "",
      no_encontre_formato_gramaje: noEncontreFormatoGramaje || "",
      alternativas_productos: alternativasProductos || "",
      productos_calidad: productosCalidad || "",
      problema_producto_calidad: problemaProductoCalidad || "",
      problema_producto_calidad_detalle: productoCalidadDetalle || "",
      comentario_producto_otro_motivo_problema: productoCalidadDetalle === "producto_otro_motivo_problema" ? productoCalidadDetalleOtro || "" : "",
      encontre_buenos_precios: encontreBuenosPrecios || "",
      ofertas_atractivas: ofertasAtractivas || "",
      entender_ofertas: entenderOfertas || "",
      local_limpio_ordenado: localLimpioOrdenado || "",
      atencion_personal: atencionPersonal || "",
      atencion_personal_sector: atencionPersonalSector || "",
      atencion_personal_problema: atencionPersonalProblema || "",
      proceso_pago: procesoPago || "",
      motivo_caja_espera_larga: motivoCajaEsperaLarga || "",
      motivo_medio_pago: motivoMedioPago || "",
      motivo_atencion_cajero: motivoAtencionCajero || "",
      motivo_otro: motivoOtro || "",
      motivo_otro_texto: motivoOtroTexto || "",
      motivo_pocas_cajas: motivoPocasCajas || "",
      motivo_precio_diferente: motivoPrecioDiferente || "",
      motivo_prioridad: motivoPrioridad || "",
      compra_anterior: compraAnterior || "",
      escala_satisfaccion: escalaSatistaccion || "",
      volver_comprar: volverComprar || "",
      tienda_id: tiendaId ? parseInt(tiendaId) : null,
      acepta_politica: aceptaPolitica ? "1" : "0",
      comentario_mejorar: comentarioMejorar || "",
      comentario_satisfaccion: comentarioSatisfaccion || "",
      comentario_compra_anterior_otro: comentarioCompraAnteriorOtro || "",
      probabilidad_recomendacion: probabilidadRecomendacion !== null ? parseInt(probabilidadRecomendacion) : null,
    };

    // Convertir a array de objetos para enviar al backend
    // const data = Object.entries(formData).map(([key, value]) => ({ key, value }));
    const data = Object.entries(formData).map(([key, value]) => ({ 
        key, 
        value: value === undefined ? null : value // Evita que valores undefined borren la clave
    }));
    console.log("Estado Recomendacion:", probabilidadRecomendacion)
    fetch("https://services.neuralactions.com/api/send_nps_makro", {
    // fetch("http://127.0.0.1:8882/send_nps_makro", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data })
    });

    // console.log("⏱️ Parcial enviado", uuid);
    // console.log(data);

  }, 10000);

  return () => clearInterval(interval);

}, [
  uuid, submitSuccess,
  nombre, dniCuitCliente, emailCliente, telefonoCliente, minutoResponder,
  satisfaccionGeneral, comentarioInsatisfaccion, facilidadCompra, contactoGestion,
  inicioCompra, distribucionComunicacion, productosBuscados, noEncontroProducto,
  noEncontroMarca, noEncontreFormatoGramaje, alternativasProductos, productosCalidad,
  problemaProductoCalidad, productoCalidadDetalle, productoCalidadDetalleOtro,
  encontreBuenosPrecios, ofertasAtractivas, entenderOfertas, localLimpioOrdenado,
  atencionPersonal, atencionPersonalSector, atencionPersonalProblema, procesoPago,
  motivoCajaEsperaLarga, motivoMedioPago, motivoAtencionCajero, motivoOtro, motivoOtroTexto,
  motivoPocasCajas, motivoPrecioDiferente, motivoPrioridad, compraAnterior, escalaSatistaccion,
  volverComprar, tiendaId, aceptaPolitica, comentarioMejorar, comentarioSatisfaccion,
  comentarioCompraAnteriorOtro, probabilidadRecomendacion
]);

// ----------------------------------------------

const onSubmit = async (e) => {
    e.preventDefault();

    let data = SerializeForm(e.target);

    data = data.filter(item => item.key !== "probabilidad_recomendacion"); 
  
    data.push({ 
      key: "probabilidad_recomendacion", 
      value: probabilidadRecomendacion !== null ? parseInt(probabilidadRecomendacion) : null 
    });

    if (uuid) {
      data.push({ key: "uuid", value: uuid });
    }

    try {
      setIsSubmitting(true); // Comienza el envío
      setsubmitError(false);
      const response = await fetch("https://services.neuralactions.com/api/send_nps_makro",
      // const response = await fetch("http://127.0.0.1:8882/send_nps_makro",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data }),
        }
      );

      if (response.ok) {
        const result = await response.json();

        if (result.uuid) {
          setUuid(result.uuid);
        }

        setSubmitSuccess(true);
        setsubmitError(false);
        setIsSubmitting(false);
      }
    } catch {
      // console.error("Error al enviar:", error);
      setsubmitError(true);
      setIsSubmitting(false);
    }
  };


  if(!ready) {
    return (null)
  }

  return (
    <div className="App">
      <div className="contenedor-logo">
        <img src={Logo} alt="Makro" />
      </div>
      <div className='back-recommender-top'></div>
      <form className='container-fluid p-3' onSubmit={onSubmit}>
      {/* --- Bloque de datos de contacto --- */}
      {numeroPregunta ===0 && (<>
      {/* ---------------------- */}
        <div className="mb-3">
          <label className="form-label">¿Podrías indicarnos la sucursal?</label>
          <select
            className="form-select"
            name="tienda_id"
            required
            defaultValue={tiendaId}
            onChange={(e) => 
              {
                setTiendaId(e.target.value);
                setTiendaError(false);
            }}
          >
            <option value="" disabled>Selecciona una opción</option>
            {sucursales.map((s) => (
              <option key={s.id} value={s.id}>
                {s.nombre}
              </option>
            ))}
          </select>
          {tiendaError && (
            <small className="text-danger">
              Por favor, seleccioná la Sucursal antes de continuar.
            </small>
          )}
        </div>

        <div className="mt-3">
          <h4 className="title">Dejanos tus datos de contacto</h4>

          {/* Campo Nombre */}
          <div className="mb-3">
            <label className="form-label">¿Cómo te llamas?</label>
            <input
              className={`form-control ${nombreError ? "input-error" : ""}`}
              type="text"
              name="nombre_apellido_cliente"
              value={nombre}
              onChange={(e) => {
                setNombre(e.target.value);
                setNombreError(false);
              }}
              required
            />
            {nombreError && (
              <small className="text-danger">
                Por favor, completá tu nombre antes de continuar.
              </small>
            )}
          </div>

        {/* Campo DNI / CUIT */}
          <div className="mb-3">
            <label className="form-label">Por favor, ¿podrías dejarnos tu DNI o CUIT?</label>
            <input
              className={`form-control ${dniCuitError ? "input-error" : ""}`}
              type="text"
              name="dni_cuit_cliente"
              value={dniCuitCliente}
              pattern="[0-9]{7,11}"
              title="Debe contener entre 7 y 11 dígitos numéricos"
              inputMode="numeric"
              onChange={(e) => {
                setDniCuitCliente(e.target.value);
                setDniCuitError(false); // Limpia el error al escribir
              }}
              required
            />
            {dniCuitError && (
              <small className="text-danger">
                Por favor, ingresá tu DNI o CUIT antes de continuar.
              </small>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Por favor, ¿Podrías indicarnos tu mail?</label>
            <input
              className={`form-control ${emailError ? "is-invalid" : ""}`}
              type="email"
              name="email_cliente"
              value={emailCliente}
              onChange={(e) => {
                setEmailCliente(e.target.value);
                setEmailError(false); // limpia el error al escribir
              }}
            />
            {emailError && (
              <div className="invalid-feedback">Por favor, ingresá un correo válido.</div>
            )}
          </div>

          {/* Botón para avanzar */}
          <div className="d-flex justify-content-center mt-4">
            <button
              type="button"
              className="btn-confirmar"
              onClick={() => {
                // 1. Evaluamos cada validación en variables booleanas locales
                const esTiendaInvalida = tiendaId === "";
                const esNombreInvalido = nombre.trim() === "";
                const esDniCuitInvalido = !dniCuitCliente || dniCuitCliente.trim() === "";
                
                const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailCliente);
                const esEmailInvalido = emailCliente !== "" && !emailValido;

                // 2. Actualizamos los estados visuales de error de todos los campos
                setTiendaError(esTiendaInvalida);
                setNombreError(esNombreInvalido);
                setDniCuitError(esDniCuitInvalido);
                setEmailError(esEmailInvalido);

                // 3. Si NINGUNO de los campos es inválido, avanzamos
                if (!esTiendaInvalida && !esNombreInvalido && !esDniCuitInvalido && !esEmailInvalido) {
                  setNumeroPregunta(numeroPregunta + 1);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
            >
              Continuar
            </button>
          </div>

        </div>        
      </>)}

        <Table >
          <tbody>
            {/* Satisfacción general */}
            {numeroPregunta ===1 && (<>
              <tr>
                <td colSpan={2}>
                  <strong>¿Qué tan satisfecho te encontrás con tu experiencia en Makro?</strong>
                </td>
              </tr>
              <tr>
                <td>
                <div className="d-flex flex-column align-items-center mt-2">
                  {/* 2025-10-30: Agregado para cambiar las caritas */}
                  <div className="face-container mt-2">
                    {options.map((opt) => (
                      <label
                          key={opt.value}
                          className={`face-option ${
                            satisfaccionGeneral === String(opt.value) ? "selected" : ""
                          }`}
                          style={{
                            backgroundColor:
                              satisfaccionGeneral === String(opt.value)
                                ? opt.color
                                : "#f5f5f5",
                          }}
                        >
                        <input
                          type="radio"
                          name="satisfaccion_general"
                          value={opt.value}
                          checked={satisfaccionGeneral === String(opt.value)}
                          onChange={(e) => 
                            {
                              setSatisfaccionGeneral(e.target.value);
                              window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                            }
                          }
                          required
                          style={{ display: "none" }}
                        />
                        <img src={opt.img} alt={opt.label} />
                      </label>
                    ))}
                  </div>
                </div>

              </td>
              </tr>
              {["1", "2","3","4","5"].includes(satisfaccionGeneral) && (
                <>
                <tr>
                  <td colSpan={2}>
                    {/* === Campo condicional === */}
                    {["1", "2"].includes(satisfaccionGeneral) && (
                      <>
                        <label className="form-label">¿Nos contarías qué estuvo mal?</label>
                        <input
                          className="form-control"
                          type="text"
                          name="comentario_insatisfaccion"
                          onChange={(e) => setComentarioInsatisfaccion(e.target.value)}
                          placeholder="Escribí tu respuesta" />
                      </>
                    )}

                    {satisfaccionGeneral === "3" && (
                      <>
                        <label className="form-label">¿Qué creés que podemos mejorar?</label>
                        <input
                          className="form-control"
                          type="text"
                          name="comentario_mejorar"
                          onChange={(e) => setComentarioMejorar(e.target.value)}
                          placeholder="Escribí tu respuesta" />
                      </>
                    )}

                    {["4", "5"].includes(satisfaccionGeneral) && (
                      <>
                        <label className="form-label">¿Nos contarías qué te gusta de nosotros?</label>
                        <input
                          className="form-control"
                          type="text"
                          name="comentario_satisfaccion"
                          onChange={(e) => setComentarioSatisfaccion(e.target.value)}
                          placeholder="Escribí tu respuesta" />
                      </>
                    )}
                  </td>
                </tr>
                {["1", "2","3"].includes(satisfaccionGeneral) && (
                  <tr>
                    <td colSpan={3}>
                      <div className="mb-3">
                        <label className="form-label">¿Podemos contactarte para dar gestión sobre tu comentario?</label>
                        <select
                          className="form-select"
                          name="contacto_gestion"
                          required
                          defaultValue={contactoGestion}
                          onChange={(e) => setContactoGestion(e.target.value)}
                        >
                          <option value="" disabled>Selecciona una opción</option>
                          <option value="ContactoGestionSi">Si quiero que me contacten</option>
                          <option value="ContactoGestionNo">No quiero que me contacten</option>
                        </select>
                      </div>

                    </td>
                  </tr>
                )}
                {["1", "2","3"].includes(satisfaccionGeneral) && contactoGestion ==="ContactoGestionSi" && (
                <tr>
                  <td colSpan={3}>
                    <>
                      <label className="form-label">Por favor, indícanos un número de contacto</label>
                      <input
                        className="form-control"
                        type="tel"
                        name="telefono_cliente"
                        onChange={(e) => setTelefonoCliente(e.target.value)}
                        pattern="^\+?[0-9]{8,15}$"
                        title="Debe contener entre 8 y 15 números. Puede empezar con +"
                        inputMode="tel"
                      />
                    </>
                  </td>
                  </tr>
                  )}
                  </>
                )
                }
                <tr>
                  <td colSpan="5" className="text-center">
                    {/* Botón para avanzar */}
                      <div className="d-flex justify-content-center mt-4">
                        <button
                          type="button"
                          className="btn-volver"
                          onClick={() => {
                            setNumeroPregunta(numeroPregunta - 1);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        >
                          Volver
                        </button>
                      </div>
                        {["1", "2","3","4","5"].includes(satisfaccionGeneral) && (<>
                          {/* Botón para avanzar */}
                          <div className="d-flex justify-content-center mt-4">
                            <button
                              type="button"
                              className="btn-confirmar"
                              onClick={() => {
                                setNumeroPregunta(numeroPregunta + 1);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                              }
                            }
                            >
                              Continuar
                            </button>
                          </div>
                        </>
                        )}
                    </td>
                </tr>
            </>)}
            
            {/* Pregunta de recomendacion del 0 a al 10*/}
            {numeroPregunta === 2 && (
              <>
                <tr>
                  <td colSpan={2}>
                    <strong> De 0 a 10. ¿Cuan probable es que recomiendes <span style={{ color: 'rgb(215, 25, 33)' }}>Makro</span> a un amigo, pariente o compañero de trabajo?</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="d-flex flex-column align-items-center">
                      <div className="face-container mt-2">
                        <TeenScaleValue
                          name='probabilidad_recomendacion'
                          minLabel='Nada probable'
                          maxLabel='Muy probable'
                          onChange={(v) => {
                            setProbabilidadRecomendacion(v);
                            // Opcional: scroll automático al botón cuando aparece
                            setTimeout(() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' }), 100);
                          }}
                          defaultValue={probabilidadRecomendacion}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="5" className="text-center">
                    <div className="d-flex justify-content-center mt-4">
                      <button
                        type="button"
                        className="btn-volver"
                        onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                      >
                        Volver
                      </button>
                    </div>

                    {/* EL BOTÓN SOLO APARECE SI HAY UN VALOR SELECCIONADO */}
                    {probabilidadRecomendacion !== null && (
                      <div className="d-flex justify-content-center mt-4">
                        <button
                          type="button"
                          className="btn-confirmar"
                          onClick={() => {
                            setNumeroPregunta(numeroPregunta + 1);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        >
                          Continuar
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              </>
            )}
            {/* Facilidad de compra */}
            {numeroPregunta ===3 && (<>
              {["1", "2","3","4","5"].includes(satisfaccionGeneral) && (
                <><tr>
                  <td colSpan={2}>
                    <strong>En general, ¿qué tan fácil o difícil fue realizar tu compra en Makro?</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="d-flex flex-column align-items-center">
                      <div className="face-container mt-2">
                        {options.map((opt) => (
                          <label
                              key={opt.value}
                              className={`face-option ${
                                facilidadCompra === String(opt.value) ? "selected" : ""
                              }`}
                              style={{
                                backgroundColor:
                                  facilidadCompra === String(opt.value)
                                    ? opt.color
                                    : "#f5f5f5",
                              }}
                            >
                            <input
                              type="radio"
                              name="facilidad_compra"
                              value={opt.value}
                              checked={facilidadCompra === String(opt.value)}
                              onChange={(e) => {setFacilidadCompra(e.target.value)
                                setNumeroPregunta(numeroPregunta+1);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
}
                              }
                              required
                              style={{ display: "none" }}
                            />
                            <img src={opt.img} alt={opt.label} />
                          </label>
                        ))}
                      </div>
                    </div>
                  </td>
                </tr></>
              )}
              <tr>
                  <td colSpan="5" className="text-center">
                   {/* Botón para avanzar */}
                    <div className="d-flex justify-content-center mt-4">
                      <button
                        type="button"
                        className="btn-volver"
                        onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                      >
                        Volver
                      </button>
                    </div>

                    {/* Botón para avanzar */}
                    {["1", "2","3","4","5"].includes(facilidadCompra) && (<>
                    <div className="d-flex justify-content-center mt-4">
                      <button
                        type="button"
                        className="btn-confirmar"
                        onClick={() => {
                          setNumeroPregunta(numeroPregunta + 1);
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                        }
                      >
                        Continuar
                      </button>
                    </div>
                    </>)}
                  </td>
                </tr>
            </>)}
          {/* ¿Nos dedicarías unos minutos para responder algunas preguntas adicionales? */}
          {minutoResponder !=="MinutoResponderNo" && (<>
            {numeroPregunta ===4 && (<>
              <tr>
                <td colSpan={3}>
                  <div className="mb-3">
                    <label className="form-label">¿Nos dedicarías unos minutos para responder algunas preguntas adicionales?</label>
                    <select
                      className="form-select"
                      name="minutos_responder"
                      required
                      defaultValue={minutoResponder}
                      onChange={(e) => {
                        const value = e.target.value;
                        setMinutoResponder(value);
                        if (value === "MinutoResponderSi") {
                          setNumeroPregunta(numeroPregunta + 1);
                        }
                      }}
                    >
                      <option value="" disabled>Selecciona una opción</option>
                      <option value="MinutoResponderSi">Si quiero responder</option>
                      <option value="MinutoResponderNo">No quiero responder</option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan="5" className="text-center">
                {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                    >
                      Volver
                    </button>
                  </div>
                {/* </td>
              </tr> */}
              
                {minutoResponder !=="" && (<>
                  {/* <tr>
                    <td colSpan="5" className="text-center"> */}
                    {/* Botón para avanzar */}
                      <div className="d-flex justify-content-center mt-4">
                        <button
                          type="button"
                          className="btn-confirmar"
                          onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                        >
                          Continuar
                        </button>
                      </div>
                        {/* </td>
                      </tr> */}
                    </>)}
                 </td>
              </tr>
              </>)}
            </>)}

          {/* Inicio de compra */}
          {(numeroPregunta ===5 ) && (<>
              <tr>
                <td colSpan={2}>
                  <strong>Al ingresar al supermercado...</strong>
                  <br />
                  ¿Qué tan sencillo fue comenzar tu compra? Considerando la señalética de acceso,
                  disponibilidad de changos/canastos y un acceso despejado.
                </td>
              </tr>
              <tr>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <div className="face-container mt-2">
                      {options.map((opt) => (
                        <label
                            key={opt.value}
                            className={`face-option ${
                              inicioCompra === String(opt.value) ? "selected" : ""
                            }`}
                            style={{
                              backgroundColor:
                                inicioCompra === String(opt.value)
                                  ? opt.color
                                  : "#f5f5f5",
                            }}
                          >
                          <input
                            type="radio"
                            name="inicio_compra"
                            value={opt.value}
                            checked={inicioCompra === String(opt.value)}
                            onChange={(e) => {setInicioCompra(e.target.value)
                              setNumeroPregunta(numeroPregunta+1);
                              window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                            }
                            required
                            style={{ display: "none" }}
                          />
                          <img src={opt.img} alt={opt.label} />
                        </label>
                      ))}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan="5" className="text-center">
                  {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                    >
                      Volver
                    </button>
                  </div>
                  {/* Botón para avanzar */}
                  {["1", "2","3","4","5"].includes(inicioCompra) && (<>
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="button"
                      className="btn-confirmar"
                      onClick={() => {
                        setNumeroPregunta(numeroPregunta + 1);
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }
                      }
                    >
                      Continuar
                    </button>
                  </div>
                  </>)}
                </td>
              </tr>
            </>)}
            
          {/* Distribución de la tienda */}
          {(numeroPregunta ===6 ) && (<>
            {["1", "2","3","4","5"].includes(inicioCompra) && (<>
              <tr>
                  <td colSpan={2}>
                    <strong>¿La distribución y comunicación de la tienda me permitieron ubicarme fácilmente?</strong>
                  </td>
              </tr>
              <tr>
                  <td>
                    <div className="d-flex flex-column align-items-center">
                      <div className="face-container mt-2">
                        {options.map((opt) => (
                          <label
                              key={opt.value}
                              className={`face-option ${
                                distribucionComunicacion === String(opt.value) ? "selected" : ""
                              }`}
                              style={{
                                backgroundColor:
                                  distribucionComunicacion === String(opt.value)
                                    ? opt.color
                                    : "#f5f5f5",
                              }}
                            >
                            <input
                              type="radio"
                              name="inicio_compra"
                              value={opt.value}
                              checked={distribucionComunicacion === String(opt.value)}
                              onChange={(e) => {
                                setDistribucionComunicacion(e.target.value)
                                setNumeroPregunta(numeroPregunta + 1);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                              }
                              }
                              required
                              style={{ display: "none" }}
                            />
                            <img src={opt.img} alt={opt.label} />
                          </label>
                        ))}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    {/* Botón para avanzar */}
                    <div className="d-flex justify-content-center mt-4">
                      <button
                        type="button"
                        className="btn-volver"
                        onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                      >
                        Volver
                      </button>
                    </div>
                    {/* Botón para avanzar */}
                    {["1", "2","3","4","5"].includes(distribucionComunicacion) && (<>
                    <div className="d-flex justify-content-center mt-4">
                      <button
                        type="button"
                        className="btn-confirmar"
                        onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                      >
                        Continuar
                      </button>
                    </div>
                    </>)}
                  </td>
                </tr>
            </>)}
          </>)}  

          {/*Alternativas de Productos */}
          {(numeroPregunta ===7 ) && (<>
             {["1", "2","3","4","5"].includes(distribucionComunicacion) && (<>
              <tr>              
                <td colSpan={2}>
                  <strong>¿Encontré distintas alternativas de los productos que necesitaba?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <div className="face-container mt-2">
                        {options.map((opt) => (
                          <label
                              key={opt.value}
                              className={`face-option ${
                                alternativasProductos === String(opt.value) ? "selected" : ""
                              }`}
                              style={{
                                backgroundColor:
                                  alternativasProductos === String(opt.value)
                                    ? opt.color
                                    : "#f5f5f5",
                              }}
                            >
                            <input
                              type="radio"
                              name="alternativas_productos"
                              value={opt.value}
                              checked={alternativasProductos === String(opt.value)}
                              onChange={(e) => {setAlternativasProductos(e.target.value)
                                setNumeroPregunta(numeroPregunta + 1);
                              window.scrollTo({ top: 0, behavior: 'smooth' });
                              }
                              }
                              required
                              style={{ display: "none" }}
                            />
                            <img src={opt.img} alt={opt.label} />
                          </label>
                        ))}
                      </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                    >
                      Volver
                    </button>
                  </div>
                  {/* Botón para avanzar */}
                      {["1", "2","3","4","5"].includes(alternativasProductos) && (<>
                          <div className="d-flex justify-content-center mt-4">
                            <button
                              type="button"
                              className="btn-confirmar"
                              onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                            >
                              Continuar
                            </button>
                          </div>
                      </>)}
                    </td>
                  </tr>
              </>)}
          </>)}

          {/* Productos buscados */}
          {(numeroPregunta ===8 ) && (<>
             {["1", "2","3","4","5"].includes(alternativasProductos) && (<>
              <tr>              
                <td colSpan={2}>
                  <strong>¿Encontré todos los productos que buscaba?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="d-flex flex-column align-items-center">
                      <div className="face-container mt-2">
                          {options.map((opt) => (
                            <label
                                key={opt.value}
                                className={`face-option ${
                                  productosBuscados === String(opt.value) ? "selected" : ""
                                }`}
                                style={{
                                  backgroundColor:
                                    productosBuscados === String(opt.value)
                                      ? opt.color
                                      : "#f5f5f5",
                                }}
                              >
                              <input
                                type="radio"
                                name="productos_buscados"
                                value={opt.value}
                                checked={productosBuscados === String(opt.value)}
                                onChange={(e) => {
                                const value = e.target.value
                                setProductosBuscados(value)
                                if (["4","5"].includes(value)) {
                                  setNumeroPregunta(9);
                                  window.scrollTo({ top: 0, behavior: 'smooth' });
                                };
                                if (["1","2","3"].includes(value)) {
                                  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                                };
                                
                                }
                              }
                                required
                                style={{ display: "none" }}
                              />
                              <img src={opt.img} alt={opt.label} />
                            </label>
                          ))}
                        </div>
                  </div>
                </td>
              </tr>
            </>)}
            <tr>
              {["1", "2","3"].includes(productosBuscados) && (<>
              <td colSpan={3}>
                <strong>¿Que producto no pudiste encontrar?</strong>
                <br></br><br></br>
                <div className="mb-3">
                  <label className="form-label">Producto</label>
                  <input className="form-control" 
                    type="text" 
                    name="no_encontro_producto" 
                    onChange={(e) => setNoEncontroProducto(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Marca</label>
                  <input className="form-control" 
                    type="text" 
                    name="no_encontro_marca" 
                    onChange={(e) => setNoEncontroMarca(e.target.value)}  
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Formato - Gramaje</label>
                  <input className="form-control" 
                    type="text" 
                    name="no_encontre_formato_gramaje" 
                    onChange={(e) => setNoEncontreFormatoGramaje(e.target.value)}
                  />
                </div>
              </td>
              </>)}
            </tr>
            <tr>
              <td>
                {/* Botón para avanzar */}
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn-volver"
                    onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                  >
                    Volver
                  </button>
                </div>
              </td>
            </tr>
            
            <tr>
              <td>
                {/* Botón para avanzar */}
              {["1", "2","3","4","5"].includes(productosBuscados) && (<>
              <div className="d-flex justify-content-center">
                <button
                  type="button"
                  className="btn-confirmar"
                  onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                >
                  Continuar
                </button>
              </div>
              </>)}
              </td>
            </tr>            
          </>)}
          
          {/* Productos de buena calidad */}
          {(numeroPregunta ===9 ) && (<>    
            {["1", "2","3","4","5"].includes(productosBuscados) && (<>
              <tr>              
                <td colSpan={2}>
                  <strong>¿Encontré productos de buena calidad?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <div className="face-container mt-2">
                        {options.map((opt) => (
                          <label
                              key={opt.value}
                              className={`face-option ${
                                productosCalidad === String(opt.value) ? "selected" : ""
                              }`}
                              style={{
                                backgroundColor:
                                  productosCalidad === String(opt.value)
                                    ? opt.color
                                    : "#f5f5f5",
                              }}
                            >
                            <input
                              type="radio"
                              name="productos_calidad"
                              value={opt.value}
                              checked={productosCalidad === String(opt.value)}
                              onChange={(e) => {
                                const value = e.target.value
                                setProductosCalidad(value)
                                setNumeroPregunta(numeroPregunta + 1)
                                if (["4","5"].includes(value)) {
                                  setNumeroPregunta(numeroPregunta + 2)};
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                }
                              }
                              required
                              style={{ display: "none" }}
                            />
                            <img src={opt.img} alt={opt.label} />
                          </label>
                        ))}
                      </div>
                  </div>
                </td>
              </tr>
              <tr>
              <td>
                {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center mt-0">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                    >
                      Volver
                    </button>
                  </div>
              </td>
              </tr>
              <tr>
                <td>
                {/* Botón para avanzar */}
                  {["1", "2","3","4","5"].includes(productosCalidad) && (<>
                  <div className="d-flex justify-content-center mt-1">
                    <button
                      type="button"
                      className="btn-confirmar"
                      onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                    >
                      Continuar
                    </button>
                  </div>
                  </>)}
                </td>
              </tr>
            </>)}
          </>)}
          
          {/* Problemas de calidad del producto alimenticio*/}
          {(numeroPregunta ===10 ) && (<>
            <tr>
              {["1", "2","3"].includes(productosCalidad) && (
                  <td colSpan={3}>
                    <div className="mb-3">
                      <label className="form-label">¿Tuviste problemas de calidad con algún producto alimenticio?</label>
                      <select
                        className="form-select"
                        name="problema_producto_calidad"
                        required
                        defaultValue={problemaProductoCalidad}
                        onChange={(e) => setProblemaProductoCalidad(e.target.value)}
                      >
                        <option value="" disabled>Selecciona una opción</option>
                        <option value="ProblemaProductoCalidadSi">Si tuve problemas</option>
                        <option value="ProblemaProductoCalidadNo">No tuve problemas</option>
                      </select>
                    </div>
                    {problemaProductoCalidad==="ProblemaProductoCalidadSi" && (
                  <td colSpan={3}>
                    <div className="mb-3">
                      <label className="form-label">¿Nos contarías cual fue el problema?</label>
                      <select
                        className="form-select"
                        name="problema_producto_calidad_detalle"
                        required
                        defaultValue={problemaProductoCalidad}
                        onChange={(e) => setProductoCalidadDetalle(e.target.value)}
                      >
                        <option value="" disabled>Selecciona una opción</option>
                        <option value="producto_mal_estado">El producto estaba en mal estado</option>
                        <option value="producto_pronto_vencer">El producto estaba pronto a vencer</option>
                        <option value="producto_sin_info_nutricional">El producto no tenía toda la información nutricional que necesitaba</option>
                        <option value="producto_otro_motivo_problema">Otro</option>
                      </select>
                    </div>
                      {productoCalidadDetalle === "producto_otro_motivo_problema" && (
                        <div className="mt-3">
                          <label className="form-label">¿Cuál fué el problema?</label>
                          <input
                            className="form-control"
                            type="text"
                            name="comentario_producto_otro_motivo_problema"
                            onChange={(e) => {
                              setProductoCalidadDetalleOtro(e.target.value);
                            }}
                            placeholder="Escribí tu respuesta" />
                        </div>
                      )}
                  </td>
              )}
                  </td>
                
              )}
            </tr>
              <td>
                {/* Botón para avanzar */}
                  {["1", "2","3"].includes(productosCalidad) && (<>
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(9)}
                    >
                      Volver
                    </button>
                  </div>
                  </>)}
              </td>
              <tr>
              <td>
              {/* Botón para avanzar */}
                  {["1", "2","3"].includes(productosCalidad) && (<>
                  <div className="d-flex justify-content-center mt-1">
                    <button
                      type="button"
                      className="btn-confirmar"
                      onClick={() => setNumeroPregunta(11)}
                    >
                      Continuar
                    </button>
                  </div>
                  </>)}
              </td>
              </tr>
          </>)}

          {/* Buenos precios */}
          {(numeroPregunta ===11 ) && (<>
            {["1", "2","3","4","5"].includes(productosCalidad) && (<>
            <tr>
                <td colSpan={2}>
                  <strong>Encontré buenos precios</strong>
                </td>
            </tr>
            <tr>
                <td>
                  <div className="d-flex flex-column align-items-center">
                      <div className="face-container mt-2">
                        {options.map((opt) => (
                          <label
                              key={opt.value}
                              className={`face-option ${
                                encontreBuenosPrecios === String(opt.value) ? "selected" : ""
                              }`}
                              style={{
                                backgroundColor:
                                  encontreBuenosPrecios === String(opt.value)
                                    ? opt.color
                                    : "#f5f5f5",
                              }}
                            >
                            <input
                              type="radio"
                              name="encontre_buenos_precios"
                              value={opt.value}
                              checked={encontreBuenosPrecios === String(opt.value)}
                              onChange={(e) => {
                                setEncontreBuenosPrecios(e.target.value)
                               setNumeroPregunta(numeroPregunta + 1);
                               window.scrollTo({ top: 0, behavior: 'smooth' });
                              }
                              }
                              required
                              style={{ display: "none" }}
                            />
                            <img src={opt.img} alt={opt.label} />
                          </label>
                        ))}
                      </div>
                  </div>
                </td>
              </tr>
              <td>
              {/* Botón para avanzar */}
                <div className="d-flex justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn-volver"
                    onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                  >
                    Volver
                  </button>
                </div>
              </td>
              <tr>
              <td>
                {/* Botón para avanzar */}
                  {["1", "2","3","4","5"].includes(encontreBuenosPrecios) && (<>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-confirmar"
                      onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                    >
                      Continuar
                    </button>
                  </div>
                  </>)}
              </td>
              </tr>
            </>)}
          </>)}

          {/* Ofertas actractivas */}
          {(numeroPregunta ===12 ) && (<>
            {["1", "2","3","4","5"].includes(encontreBuenosPrecios) && (<>  
              <tr>
                <td colSpan={2}>
                  <strong>Encontré ofertas actractivas para mi</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <div className="face-container mt-2">
                      {options.map((opt) => (
                        <label
                            key={opt.value}
                            className={`face-option ${
                              ofertasAtractivas === String(opt.value) ? "selected" : ""
                            }`}
                            style={{
                              backgroundColor:
                                ofertasAtractivas === String(opt.value)
                                  ? opt.color
                                  : "#f5f5f5",
                            }}
                          >
                          <input
                            type="radio"
                            name="ofertas_atractivas"
                            value={opt.value}
                            checked={ofertasAtractivas === String(opt.value)}
                            onChange={(e) => {
                              setOfertasAtractivas(e.target.value)
                              setNumeroPregunta(numeroPregunta + 1);
                              window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                            }
                            required
                            style={{ display: "none" }}
                          />
                          <img src={opt.img} alt={opt.label} />
                        </label>
                      ))}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                    >
                      Volver
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* Botón para avanzar */}
                  {["1", "2","3","4","5"].includes(ofertasAtractivas) && (<>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-confirmar"
                      onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                    >
                      Continuar
                    </button>
                  </div>
                  </>)}
                </td>
              </tr>
              
            </>)}
          </>)}  

          {/* Entender ofertas */}
          {(numeroPregunta ===13 ) && (<>
            {["1", "2","3","4","5"].includes(ofertasAtractivas) && (<>
              <tr>
                <td colSpan={2}>
                  <strong>Me fue fácil entender las ofertas y los precios de los productos</strong>
                </td>
              </tr>
              <tr>                
                <td>
                  <div className="d-flex flex-column align-items-center">
                      <div className="face-container mt-2">
                        {options.map((opt) => (
                          <label
                              key={opt.value}
                              className={`face-option ${
                                entenderOfertas === String(opt.value) ? "selected" : ""
                              }`}
                              style={{
                                backgroundColor:
                                  entenderOfertas === String(opt.value)
                                    ? opt.color
                                    : "#f5f5f5",
                              }}
                            >
                            <input
                              type="radio"
                              name="entender_ofertas"
                              value={opt.value}
                              checked={entenderOfertas === String(opt.value)}
                              onChange={(e) => {
                                setEntenderOfertas(e.target.value)
                                setNumeroPregunta(numeroPregunta + 1);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                              }
                              }
                              required
                              style={{ display: "none" }}
                            />
                            <img src={opt.img} alt={opt.label} />
                          </label>
                        ))}
                      </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                    >
                      Volver
                    </button>
                </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* Botón para avanzar */}
                  {["1", "2","3","4","5"].includes(entenderOfertas) && (<>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-confirmar"
                      onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                    >
                      Continuar
                    </button>
                  </div>
                  </>)}
                </td>
              </tr>

              
            </>)}
          </>)}

          {/* Local limpio y ordenado */}
          {(numeroPregunta ===14 ) && (<>
            {["1", "2","3","4","5"].includes(entenderOfertas) && (<>
              <tr>
                <td colSpan={2}>
                  <strong>El local se encontraba limpio y ordenado</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="d-flex flex-column align-items-center">
                      <div className="face-container mt-2">
                        {options.map((opt) => (
                          <label
                              key={opt.value}
                              className={`face-option ${
                                localLimpioOrdenado === String(opt.value) ? "selected" : ""
                              }`}
                              style={{
                                backgroundColor:
                                  localLimpioOrdenado === String(opt.value)
                                    ? opt.color
                                    : "#f5f5f5",
                              }}
                            >
                            <input
                              type="radio"
                              name="local_limpio_ordenado"
                              value={opt.value}
                              checked={localLimpioOrdenado === String(opt.value)}
                              onChange={(e) => {
                                setLocalLimpioOrdenado(e.target.value)
                                setNumeroPregunta(numeroPregunta + 1)
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                ;}
                              }
                              required
                              style={{ display: "none" }}
                            />
                            <img src={opt.img} alt={opt.label} />
                          </label>
                        ))}
                      </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* Botón para avanzar */}
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn-volver"
                    onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                  >
                    Volver
                  </button>
                </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* Botón para avanzar */}
                  {["1", "2","3","4","5"].includes(localLimpioOrdenado) && (<>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-confirmar"
                      onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                    >
                      Continuar
                    </button>
                  </div>
                  </>)}
                </td>
              </tr>
              
            </>)}
          </>)}

          {/* Satifaccion por la atención */}
          {(numeroPregunta ===15 ) && (<>
            {["1", "2","3","4","5"].includes(localLimpioOrdenado) && (<>
              <tr>
                <td colSpan={2}>
                  <strong>En general, ¿qué tan satisfecho te encontrás con la atención del personal en Makro?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="d-flex flex-column align-items-center">
                      <div className="face-container mt-2">
                        {options.map((opt) => (
                          <label
                              key={opt.value}
                              className={`face-option ${
                                atencionPersonal === String(opt.value) ? "selected" : ""
                              }`}
                              style={{
                                backgroundColor:
                                  atencionPersonal === String(opt.value)
                                    ? opt.color
                                    : "#f5f5f5",
                              }}
                            >
                            <input
                              type="radio"
                              name="atencion_personal"
                              value={opt.value}
                              checked={atencionPersonal === String(opt.value)}
                              onChange={(e) => {
                                const value = e.target.value
                                setAtencionPersonal(value)
                                setNumeroPregunta(numeroPregunta + 1)
                                if (["4","5"].includes(value)) {
                                  setNumeroPregunta(numeroPregunta + 2);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                              }
                              }
                              }
                              required
                              style={{ display: "none" }}
                            />
                            <img src={opt.img} alt={opt.label} />
                          </label>
                        ))}
                      </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                    >
                      Volver
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* Botón para avanzar */}
                  {["4","5"].includes(atencionPersonal) && (<>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-confirmar"
                      onClick={() => setNumeroPregunta(17)}
                    >
                      Continuar
                    </button>
                  </div>
                  </>)}
                </td>
              </tr>
              <tr>
                <td>
                  {/* Botón para avanzar */}
                  {["1", "2","3"].includes(atencionPersonal) && (<>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-confirmar"
                      onClick={() => setNumeroPregunta(16)}
                    >
                      Continuar
                    </button>
                  </div>
                  </>)}
                </td>
              </tr>
            </>)}
          </>)}

          {/* Atencion al personal*/}
          {(numeroPregunta ===16 ) && (<>
            {["1", "2","3"].includes(atencionPersonal) && (<>
            <tr>
              <td colSpan={3}>
                <strong>¿Nos contarías donde y cuál fue el problema con nuestro personal?</strong>
                <br></br><br></br>
                <div className="mb-3">
                  <label className="form-label">Sector</label>
                  <input className="form-control" 
                    type="text" 
                    name="atencion_personal_sector" 
                    onChange={(e) => setAtencionPersonalSector(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Problema</label>
                  <input className="form-control" 
                    type="text" 
                    name="atencion_personal_problema" 
                    onChange={(e) => setAtencionPersonalProblema(e.target.value)}
                    />
                </div>
              </td>
              </tr>
              <tr>
                <td>
                {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                    >
                      Volver
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-confirmar"
                      onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                    >
                      Continuar
                    </button>
                  </div>
                </td>
              </tr>
              
            </>)}
          </>)}

          {/* Proceso de pago */}
          {(numeroPregunta ===17 ) && (<>  
            {["1", "2","3","4","5"].includes(atencionPersonal) && (<>
              <tr>
                <td colSpan={2}>
                  <strong>¿Qué tan satisfecho te encontrás con el proceso de pago?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="d-flex flex-column align-items-center">
                      <div className="face-container mt-2">
                        {options.map((opt) => (
                          <label
                              key={opt.value}
                              className={`face-option ${
                                procesoPago === String(opt.value) ? "selected" : ""
                              }`}
                              style={{
                                backgroundColor:
                                  procesoPago === String(opt.value)
                                    ? opt.color
                                    : "#f5f5f5",
                              }}
                            >
                            <input
                              type="radio"
                              name="proceso_pago"
                              value={opt.value}
                              checked={procesoPago === String(opt.value)}
                              onChange={(e) => 
                              {
                                const value = e.target.value
                                setProcesoPago(value)
                                if (["4","5"].includes(value)) {
                                  setNumeroPregunta(19);
                                  window.scrollTo({ top: 0, behavior: 'smooth' });
                                  }
                                if (["1","2","3"].includes(value)) {
                                  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                                  }
                              }
                              }
                              required
                              style={{ display: "none" }}
                            />
                            <img src={opt.img} alt={opt.label} />
                          </label>
                        ))}
                      </div>
                  </div>
                </td>
              </tr>
            </>)}

              {["1", "2","3"].includes(procesoPago) && (<>
                <tr>
                <td colSpan={3}>
                  <div className="mt-3">
                    <label className="form-label">
                      ¿Qué tipo de problema tuviste?
                    </label>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="motivo_caja_espera_larga"
                        id="motivo_caja_espera_larga"
                        value="El tiempo de espera fue muy largo"
                        onChange={(e) => setMotivoCajaEsperaLarga(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="motivo_caja_espera_larga">
                        El tiempo de espera fue muy largo
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="motivo_pocas_cajas"
                        id="motivo_pocas_cajas"
                        value="Hay pocas cajas disponibles"
                        onChange={(e) => setMotivoPocasCajas(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="motivo_pocas_cajas">
                        Hay pocas cajas disponibles
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="motivo_medio_pago"
                        id="motivo_medio_pago"
                        value="No pude pagar con el medio de pago que quería"
                        onChange={(e) => setMotivoMedioPago(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="motivo_medio_pago">
                        No pude pagar con el medio de pago que quería
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="motivo_precio_diferente"
                        id="motivo_precio_diferente"
                        onChange={(e) => setMotivoPrecioDiferente(e.target.value)}
                        value="El precio del producto no era el mismo que vi mientras realizaba mi compra"
                      />
                      <label className="form-check-label" htmlFor="motivo_precio_diferente">
                        El precio del producto no era el mismo que vi mientras realizaba mi compra
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="motivo_atencion_cajero"
                        id="motivo_atencion_cajero"
                        onChange={(e) => setMotivoAtencionCajero(e.target.value)}
                        value="La atención de cajera o cajero no fue la adecuada"
                      />
                      <label className="form-check-label" htmlFor="motivo_atencion_cajero">
                        La atención de cajera o cajero no fue la adecuada
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="motivo_prioridad"
                        id="motivo_prioridad"
                        onChange={(e) => setMotivoPrioridad(e.target.value)}
                        value="No se respeta las cajas de prioridad"
                      />
                      <label className="form-check-label" htmlFor="motivo_prioridad">
                        No se respeta las cajas de prioridad
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="motivo_otro"
                        id="motivo_otro"
                        onChange={(e) => setMotivoOtro(e.target.value)}
                        value="Otro"
                      />
                      <label className="form-check-label" htmlFor="motivo_otro">
                        Otro
                      </label>
                    </div>

                    <div className="mt-2">
                      <input
                        className="form-control"
                        type="text"
                        name="motivo_otro_texto"
                        onChange={(e) => setMotivoOtroTexto(e.target.value)}
                        placeholder="Otro: ..."
                      />
                    </div>
                  </div>

                </td>
                </tr>
              </>)}
              {/* Botón para avanzar */}
              {["4","5"].includes(procesoPago) && (<>
                <tr>
                  <td>      
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(15)}
                    >
                      Volver
                    </button>
                  </div>
                  
                </td>
              </tr>
              </>)}
              {/* Botón para avanzar */}
              {["1","2","3"].includes(procesoPago) && (<>
                <tr>
                  <td>      
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(16)}
                    >
                      Volver
                    </button>
                  </div>
                  
                </td>
              </tr>
              </>)}
              {["1","2","3","4","5"].includes(procesoPago) && (<>
                <tr>
                  <td>
                  {/* Botón para avanzar */}
                    <div className="d-flex justify-content-center">
                      <button
                        type="button"
                        className="btn-confirmar"
                        onClick={() => setNumeroPregunta(19)}
                      >
                        Continuar
                      </button>
                    </div>
                </td>
              </tr>
              </>)}
          </>)}

            
          {/* Donde hiciste compras recientemente */}
          {(numeroPregunta ===19 ) && (<>
            {["1", "2","3","4","5"].includes(procesoPago) && (<>
              <tr>
                <td colSpan={3}>
                    <div className="mb-3">
                      <strong>Para terminar, ¿nos contarías si hiciste compras recientemente en alguno de estos lugares?</strong>
                      <select
                        className="form-select"
                        name="compra_anterior"
                        defaultValue={compraAnterior}
                        onChange={(e) => setCompraAnterior(e.target.value)}
                        required
                      >
                        <option value="" disabled>Selecciona una opción</option>
                        <option value="compra_anterior_vital">Vital</option>
                        <option value="compra_anterior_diarco">Diarco</option>
                        <option value="compra_anterior_yaguar">Yaguar</option>
                        <option value="compra_anterior_maxi_carrefour">Maxi Carrefour</option>
                        <option value="compra_anterior_maxiconsumo">Maxiconsumo</option>
                        <option value="compra_anterior_nini">Nini</option>
                        <option value="compra_anterior_carrefour">Carrefour</option>
                        <option value="compra_anterior_coto">Coto</option>
                        <option value="compra_anterior_chango_mas">Chango Mas</option>
                        <option value="compra_anterior_dia">Día</option>
                        <option value="compra_anterior_cooperativa_obrera">Cooperativa Obrera</option>
                        <option value="compra_anterior_la_anonima">La Anónima</option>
                        <option value="compra_anterior_libertad">Libertad</option>
                        <option value="compra_anterior_toledo">Toledo</option>
                        <option value="compra_anterior_almacen_de_barrio">Almacén de barrio</option>
                        <option value="compra_anterior_carniceria">Carnicería</option>
                        <option value="compra_anterior_panaderia">Panadería</option>
                        <option value="compra_anterior_verduleria_fruteria">Verdulería/Frutería</option>
                        <option value="compra_anterior_dieteticas">Dietéticas</option>
                        <option value="compra_anterior_otro">Otro</option>
                      </select>
                    </div>
                      {compraAnterior === "compra_anterior_otro" && (
                        <div className="mt-3">
                          <label className="form-label">¿Donde compraste?</label>
                          <input
                            className="form-control"
                            type="text"
                            name="comentario_compra_anterior_otro"
                            onChange={(e) => setComentarioCompraAnteriorOtro(e.target.value)}
                            placeholder="Escribí tu respuesta" />
                        </div>
                      )}
                  </td>
                </tr>
              <tr>
                <td>
                {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center mt-1">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => {
                      setNumeroPregunta(17)
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                      }}
                    >
                      Volver
                    </button>
                  </div>
                </td>
              </tr>
              {compraAnterior !== "" && (<>
              {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center mt-1">
                    <button
                      type="button"
                      className="btn-confirmar"
                      onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                    >
                      Continuar
                    </button>
                  </div>
               </>)}
            </>)}
          </>)}
          {(numeroPregunta ===20 ) && (<>
              {compraAnterior !== "" && (<>
                <tr>
                  <td colSpan={2}>
                    <strong>En base en tu experiencia en la tienda elegida, ¿cuán satisfecho te encontrás?</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="d-flex flex-column align-items-center">
                      <div className="face-container mt-2">
                        {options.map((opt) => (
                          <label
                              key={opt.value}
                              className={`face-option ${
                                escalaSatistaccion === String(opt.value) ? "selected" : ""
                              }`}
                              style={{
                                backgroundColor:
                                  escalaSatistaccion === String(opt.value)
                                    ? opt.color
                                    : "#f5f5f5",
                              }}
                            >
                            <input
                              type="radio"
                              name="escala_satisfaccion"
                              value={opt.value}
                              checked={escalaSatistaccion === String(opt.value)}
                              onChange={(e) => {
                                setEscalaSatistaccion(e.target.value)
                                setNumeroPregunta(numeroPregunta + 1);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                              }
                              }
                              required
                              style={{ display: "none" }}
                            />
                            <img src={opt.img} alt={opt.label} />
                          </label>
                        ))}
                      </div>
                    </div>
                  </td>
                </tr>
                <td>
                  {/* Botón para avanzar */}
                  <div className="d-flex justify-content-center mt-1">
                    <button
                      type="button"
                      className="btn-volver"
                      onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                    >
                      Volver
                    </button>
                  </div>
                  {escalaSatistaccion!=="" && (<>
                    {/* Botón para avanzar */}
                        <div className="d-flex justify-content-center mt-1">
                          <button
                            type="button"
                            className="btn-confirmar"
                            onClick={() => setNumeroPregunta(numeroPregunta + 1)}
                          >
                            Continuar
                          </button>
                        </div>
                    </>)}
                  </td>
              </>)}
          </>)}

          {(numeroPregunta ===21 ) && (<>
            {["1", "2","3","4","5"].includes(escalaSatistaccion) && (<>
              <tr>
                <td colSpan={3}>
                    <div className="mb-3">
                      <strong>Dada tu experiencia en Makro, ¿volverías a comprar?</strong>
                      <select
                        className="form-select"
                        name="volver_comprar"
                        required
                        defaultValue={volverComprar}
                        onChange={(e) => {
                          setVolverComprar(e.target.value);
                          setNumeroPregunta(numeroPregunta + 1);
                        }}
                        
                      >
                        <option value="" disabled>Selecciona una opción</option>
                        <option value="seguridad_volver_comprar">Con toda seguridad volveré a comprar</option>
                        <option value="duda_volver_comprar">No tengo claro si volveré a comprar</option>
                        <option value="no_volver_comprar">Por ningún motivo volveré a comprar</option>
                      </select>
                      </div>
                  </td>
              </tr>
              <tr>
                <td>
                    {/* Botón para avanzar */}
                      <div className="d-flex justify-content-center mt-4">
                        <button
                          type="button"
                          className="btn-volver"
                          onClick={() => setNumeroPregunta(numeroPregunta - 1)}
                        >
                          Volver
                        </button>
                      </div>
                      {volverComprar!=="" && (<>
                        {/* Botón para avanzar */}
                        <div className="d-flex justify-content-center mt-4">
                          <button
                            type="button"
                            className="btn-confirmar"
                            onClick={() => setNumeroPregunta(22)}
                          >
                            Continuar
                          </button>
                        </div>
                      </>)}
                  </td>
              </tr>
            </>)}
          </>)}
            {/* ---------Fin bloque mas info ------------------- */}      
        </tbody>
      </Table>
      
      {/* Botón enviar y variables ocultas */}
      {(numeroPregunta ===22 || minutoResponder ==="MinutoResponderNo") && (<>
        {!isSubmitting && !submitSuccess && (<>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="acepto_politica"
              checked={aceptaPolitica}
              onChange={(e) => setAceptaPolitica(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="acepto_politica">
              Acepto la&nbsp;
              <a href="https://makro.com.ar/politicas/" target="_blank" rel="noreferrer">
                política de privacidad
              </a>
            </label>
          </div>
          {( minutoResponder ==="MinutoResponderSi") && (<>
          {/* Botón para avanzar */}
            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                className="btn-volver"
                onClick={() => setNumeroPregunta(numeroPregunta - 1)}
              >
                Volver
              </button>
            </div>
            <br></br>
            </>
          )}
          {( minutoResponder ==="MinutoResponderNo") && (<>
          {/* Botón para avanzar */}
            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                className="btn-volver"
                onClick={() => {
                  setNumeroPregunta(2);
                  setMinutoResponder("MinutoResponderSi");
                }}
              >
                Volver
              </button>
            </div>
            <br></br>
            </>
          )}
        </>)}
        <div className='d-flex flex-column align-items-center' name='btn_submit'>
          {!isSubmitting && !submitSuccess && (
            // <Button type="submit" disabled={probabilidadRecomendacion === -1 || !aceptaPolitica}
            //  style={{ color: 'white', backgroundColor: 'rgba(215, 25, 33,255)' }} >Confirmar encuesta</Button>
            <Button type="submit" className="btn-confirmar" disabled={!aceptaPolitica}
             style={{ color: 'white', backgroundColor: 'rgba(215, 25, 33,255)' }} >Confirmar encuesta</Button>
          )}
          {isSubmitting && !submitSuccess && !submitError && <p>Enviando encuesta...</p>}
          {submitSuccess && <p>Encuesta enviada con éxito! Muchas gracias por tus respuestas.</p>}
        </div>
        <div className='d-flex justify-content-center'>
        {submitError && isSubmitting && !submitSuccess && (
            <Button type="submit" >Reintentar enviar encuesta</Button>
          )}
        </div>
        <div className='d-flex justify-content-center'>
        {isSubmitting && !submitSuccess && submitError && <p>Error en el envío de la encuesta, por favor intenta nuevamente.</p>}
        </div>

        <input type="hidden" name="tienda_id" defaultValue={tiendaId}/>
        <input type="hidden" name="envio_fecha_hora" defaultValue={today}/>
        <input type="hidden" name="visita_fecha" defaultValue={today}/>
        <input type="hidden" name="fecha_compra" value={today} />
        <input type="hidden" name="fecha_respuesta" value={today} />
        <input type="hidden" name="acepta_politica" value={aceptaPolitica ? "1" : "0"} />

        {/* Datos del cliente */}
        <input type="hidden" name="nombre_apellido_cliente" value={nombre || ""} />
        <input type="hidden" name="dni_cuit_cliente" value={dniCuitCliente || ""} />
        <input type="hidden" name="email_cliente" value={emailCliente || ""} />
        <input type="hidden" name="telefono_cliente" value={telefonoCliente || ""} />

        <input type="hidden" name="minutos_responder" value={minutoResponder || ""} />

        {/* Preguntas de satisfacción */}
        <input type="hidden" name="satisfaccion_general" value={satisfaccionGeneral || ""} />
        <input type="hidden" name="comentario_insatisfaccion" value={comentarioInsatisfaccion || ""} />
        <input type="hidden" name="probabilidad_recomendacion" defaultValue={probabilidadRecomendacion}/>

        {/* Experiencia en el local */}

        <input type="hidden" name="facilidad_compra" value={facilidadCompra || ""} />
        <input type="hidden" name="contacto_gestion" value={contactoGestion || ""} />
        <input type="hidden" name="inicio_compra" value={inicioCompra || ""} />
        <input type="hidden" name="distribucion_comunicacion" value={distribucionComunicacion || ""} />


      {/* Productos */}
        <input type="hidden" name="productos_buscados" value={productosBuscados || ""} />
        <input type="hidden" name="no_encontro_producto" value={noEncontroProducto || ""} />
        <input type="hidden" name="no_encontro_marca" value={noEncontroMarca || ""} />
        <input type="hidden" name="no_encontre_formato_gramaje" value={noEncontreFormatoGramaje || ""} />
        <input type="hidden" name="alternativas_productos" value={alternativasProductos || ""} />
        <input type="hidden" name="productos_calidad" value={productosCalidad || ""} />
        <input type="hidden" name="problema_producto_calidad" value={problemaProductoCalidad || ""} />
        <input type="hidden" name="problema_producto_calidad_detalle" value={productoCalidadDetalle || ""} />
        <input
          type="hidden"
          name="comentario_producto_otro_motivo_problema"
          value={
            productoCalidadDetalle === "producto_otro_motivo_problema"
              ? productoCalidadDetalleOtro || ""
              : ""
          }
        />


      {/* Ofertas y precios */}
      <input type="hidden" name="encontre_buenos_precios" value={encontreBuenosPrecios || ""} />
      <input type="hidden" name="ofertas_atractivas" value={ofertasAtractivas || ""} />
      <input type="hidden" name="entender_ofertas" value={entenderOfertas || ""} />
      <input type="hidden" name="local_limpio_ordenado" value={localLimpioOrdenado || ""} />

      {/* Atención y pago */}
      <input type="hidden" name="atencion_personal" value={atencionPersonal || ""} />
      <input type="hidden" name="atencion_personal_sector" value={atencionPersonalSector || ""} />
      <input type="hidden" name="atencion_personal_problema" value={atencionPersonalProblema || ""} />
      <input type="hidden" name="proceso_pago" value={procesoPago || ""} />
      <input type="hidden" name="motivo_caja_espera_larga" value={motivoCajaEsperaLarga || ""} />
      <input type="hidden" name="motivo_medio_pago" value={motivoMedioPago || ""} />
      <input type="hidden" name="motivo_atencion_cajero" value={motivoAtencionCajero || ""} />
      <input type="hidden" name="motivo_otro" value={motivoOtro || ""} />
      <input type="hidden" name="motivo_otro_texto" value={motivoOtroTexto || ""} />
      <input type="hidden" name="motivo_pocas_cajas" value={motivoPocasCajas || ""} />
      <input type="hidden" name="motivo_precio_diferente" value={motivoPrecioDiferente || ""} />
      <input type="hidden" name="motivo_prioridad" value={motivoPrioridad || ""} />

      {/* Compra y lealtad */}
      <input type="hidden" name="compra_anterior" value={compraAnterior || ""} />
      <input type="hidden" name="escala_satisfaccion" value={escalaSatistaccion || ""} />
      <input type="hidden" name="volver_comprar" value={volverComprar || ""} />

      {/* Comentarios generales */}
      <input type="hidden" name="comentario_mejorar" value={comentarioMejorar || ""} />
      <input type="hidden" name="comentario_satisfaccion" value={comentarioSatisfaccion || ""} />
      <input type="hidden" name="comentario_compra_anterior_otro" value={comentarioCompraAnteriorOtro || ""} />
        
      </>)}
      </form>
      <div className='back-recommender-bottom'>
      </div>
    </div>    
  );
}

export default App;
